import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LoadingIndicatorService {
  private counter: number;

  header: string;
  content: string;

  // Emits whenever the visibility/header/content changes so the LoadingIndicatorComponent
  // can pick up the new state on the next macrotask (avoids NG0100 when show()/hide()
  // toggle within the same change-detection tick).
  private stateSubject = new BehaviorSubject<void>(undefined);
  public readonly state$: Observable<void> = this.stateSubject.asObservable();

  constructor() {
    this.counter = 0;
  }

  public show(header: string = null, content: string = null): void {
    header = header || 'Loading, please wait...';
    this.header = header;
    this.content = content;
    this.counter++;
    this.stateSubject.next();
  }

  public hide(): void {
    this.counter--;
    if (!this.isVisible()) {
      this.header = null;
      this.content = null;
    }
    this.stateSubject.next();
  }

  public isVisible(): boolean {
    return this.counter > 0;
  }
}
